import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultPRD3011_R01Filter, PRD3011_R01Filter, usePRD3011_R01Store } from 'src/containers/mes/PRD/PRD3011_R01/Store_PRD3011_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { downloadExcel_PRD3011_R01, getPdfBlob_PRD3011_R01, getPRD3011_R01AllCount, getPRD3011_R01InspectList, getPRD3011_R01List, getPRD3011_R01ProductResultList, patchPRD3011_R01, postPRD3011_R01, getPRD3011_R01DetailList, getPRD3011_R01DetailStockList, getPRD3011_R01One } from "./Api_PRD3011_R01";
import { defaultPRD3011_R01DowntimeDto, defaultPRD3011_R01HeaderDto, defaultPRD3011_R01InspectDto, PRD3011_R01DowntimeDto, PRD3011_R01Dto, PRD3011_R01HeaderDto, PRD3011_R01InspectDto, PRD3011_R01ProductResultDto, defaultPRD3011_R01DetailDto, PRD3011_R01DetailDto } from './Dto_PRD3011_R01';
import { validateEditBadQtyAgainstInspectList } from './inspectBadQtyUtil_PRD3011_R01';
import { aggregatePRD3011_R01DetailList, findAggregatedDetailItem, } from './Util_PRD3011_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, toLocalDateTime, validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { useItemQzPrint } from 'src/hooks/useItemQzPrint';
import { PRD3011_R01_buildItemLabelData } from './labelDataBuilder_PRD3011_R01';
import { ItemLabelPrintData } from 'src/apis/itemLabelApi';
import { getDefaultLabelPrintAuto } from 'src/utils/label/labelPrintAutoProgramUtil';
import qz from 'qz-tray';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	PRD3011_R01_DOWNTIMEROW_VALIDATE,
	PRD3011_R01_HEADERROW_VALIDATE,
	PRD3011_R01_INSPECTROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useWarehouseValidate } from 'src/utils/warehouse/WarehouseValidateContext';

interface Props {
	gridRef: React.RefObject<AgGridReact<PRD3011_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<PRD3011_R01DetailDto> | null>;
	inspectGridRef: React.RefObject<AgGridReact<PRD3011_R01InspectDto> | null>;
	downtimeGridRef: React.RefObject<AgGridReact<PRD3011_R01DowntimeDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_PRD3011_R01 = (props: Props) => {
	const { printPdfFromBlob } = useQzPrint();
	const { printBulkItemLabel } = useItemQzPrint();

	const {
		gridRef, detailGridRef, inspectGridRef, downtimeGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { faultyValueList, downtimeValueList, itemStatusList, moneyCdList, vatTypeList, wmsCdList, compCdList, employeeCdList, workPlaceList, warehouseCdList, programList } = useCommonCodeStore();

	const defaultLabelPrintAuto = useMemo(
		() => getDefaultLabelPrintAuto(programList),
		[programList]
	);
	const {
		PRD3011_R01Filter, setPRD3011_R01Filter,
		PRD3011_R01PastFilter, setPRD3011_R01PastFilter,
		PRD3011_R01List, setPRD3011_R01List,
		editPRD3011_R01, setEditPRD3011_R01,
		selectedPRD3011_R01, setSelectedPRD3011_R01, 
		deletedPRD3011_R01DetailList, setDeletedPRD3011_R01DetailList, addDeletedPRD3011_R01DetailList, removeDeletedPRD3011_R01DetailList, 
		selectedPRD3011_R01DetailList, setSelectedPRD3011_R01DetailList, addSelectedPRD3011_R01DetailList, removeSelectedPRD3011_R01DetailList,
		PRD3011_R01DetailList, setPRD3011_R01DetailList, insertPRD3011_R01DetailList,
		originalPRD3011_R01DetailList, setOriginalPRD3011_R01DetailList,
		PRD3011_R01InspectList, setPRD3011_R01InspectList, insertPRD3011_R01InspectList,
		deletedPRD3011_R01InspectList, setDeletedPRD3011_R01InspectList, addDeletedPRD3011_R01InspectList, removeDeletedPRD3011_R01InspectList,
		selectedPRD3011_R01InspectList, setSelectedPRD3011_R01InspectList, addSelectedPRD3011_R01InspectList, removeSelectedPRD3011_R01InspectList,
		originalPRD3011_R01InspectList, setOriginalPRD3011_R01InspectList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		productResultComplete, setProductResultComplete,
		initData, 
		warehouseCdListToUseList, outWarehouseCdListToUseList, badWarehouseCdListToUseList,
		setScrollTop, setDetailScrollTop, setInspectScrollTop,
	} = usePRD3011_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { validateWorkplaceWarehouse } = useWarehouseValidate();

	useFetchActionbarAuth("PRD3011_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedPRD3011_R01 || !selectedPRD3011_R01.productResultNo) {
				showWarning("출력할 생산실적번호를 선택하세요.");
				setMessage("출력할 생산실적번호를 선택하세요.");
				return;
			}
			setLoadingSpinner(true);
			try {
				const blob = await getPdfBlob_PRD3011_R01(selectedPRD3011_R01.productResultNo);
				if (qz.websocket.isActive()) {
					const ok = await printPdfFromBlob(blob, "report1");
					if (ok) {
						showSuccess("PDF 출력을 완료하였습니다.");
					} else {
						const fileURL = URL.createObjectURL(blob);
						window.open(fileURL, "_blank");
						setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					}
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
				}
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			} finally {
				setLoadingSpinner(false);
			}
	}, [selectedPRD3011_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedPRD3011_R01) {
			showWarning("선택된 생산실적내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_PRD3011_R01('', selectedPRD3011_R01.productResultNo, PRD3011_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '생산실적 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedPRD3011_R01])

	const getParams = (filter: PRD3011_R01Filter) => {
		const params: Partial<PRD3011_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			compCd: filter.compCd || undefined,
			compNm: filter.compNm || undefined,
			workplaceCd: filter.workplaceCd || undefined,
			itemCd: filter.itemCd || undefined,
			itemNm: filter.itemNm || undefined,
			workEmp: filter.workEmp || undefined,
			workEmpNm: filter.workEmpNm || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getPRD3011_R01AllCount(getParams(PRD3011_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PRD3011_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setInspectScrollTop(null);
		setLoadingSpinner(true);		
	
		const responseData = (await getPRD3011_R01List(
			'',
			getParams(PRD3011_R01Filter),
			PRD3011_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as PRD3011_R01HeaderDto[];
		setPRD3011_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedPRD3011_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedPRD3011_R01?.salBillNo)
			);
			setPRD3011_R01PastFilter(PRD3011_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedPRD3011_R01(undefined);
			setPRD3011_R01List([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [PRD3011_R01Filter, PRD3011_R01List, setPRD3011_R01List, setPRD3011_R01PastFilter, setSelectedPRD3011_R01, selectedPRD3011_R01, setScrollTop, setDetailScrollTop, setInspectScrollTop])

	const fetchOne = useCallback(async () => {
		if (!selectedPRD3011_R01) return;
		setLoadingSpinner(true);

		const response = await getPRD3011_R01One(selectedPRD3011_R01.productOrderNo);

		if(!response.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			setLoadingSpinner(false);
			return undefined;
		}

		//입고, 출고, 불량창고 코드 검증
		const warehouseResult = validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: selectedPRD3011_R01?.workplaceCd ?? workPlaceList[0].workplaceCd ?? '',
		});
		if (!warehouseResult.valid || warehouseResult.mode !== 'workplace') {
			setLoadingSpinner(false);
			return undefined;
		}
		const { logicCenter, inWarehouseCd, outWarehouseCd, badWarehouseCd } = warehouseResult;

		response.data.data.logicCenter = logicCenter || wmsCdList[0].minorCd;
		response.data.data.warehouseCd = validateString(response.data.data.warehouseCd) ? response.data.data.warehouseCd : inWarehouseCd[0].warehouseCd;
		response.data.data.outWarehouseCd = validateString(response.data.data.outWarehouseCd) ? response.data.data.outWarehouseCd : outWarehouseCd[0].warehouseCd;
		response.data.data.badWarehouseCd = validateString(response.data.data.badWarehouseCd) ? response.data.data.badWarehouseCd : badWarehouseCd[0].warehouseCd;

		setEditPRD3011_R01(response.data.data);

		setLoadingSpinner(false);
		return response.data.data as PRD3011_R01HeaderDto;
	}, [selectedPRD3011_R01, setEditPRD3011_R01, setLoadingSpinner, workPlaceList, wmsCdList, warehouseCdList, validateWorkplaceWarehouse])

	const defaultPRD3011_R01HeaderRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3011_R01_HEADERROW_VALIDATE, {
				compCdList,
				itemStatusList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3011_R01HeaderDto }; }

		const warehouseResult = validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: workPlaceList[0]?.workplaceCd ?? '',
		});
		if (!warehouseResult.valid || warehouseResult.mode !== 'workplace') {
			return { ...defaultPRD3011_R01HeaderDto };
		}
		const { logicCenter: warehouseLogicCenter, inWarehouseCd, outWarehouseCd, badWarehouseCd } = warehouseResult;

		return {
			...defaultPRD3011_R01HeaderDto,
			compCd: compCdList[0].compCd,
			workplaceCd: workPlaceList[0].workplaceCd,
			logicCenter: warehouseLogicCenter,
			warehouseCd: inWarehouseCd[0].warehouseCd,
			outWarehouseCd: outWarehouseCd[0].warehouseCd,
			badWarehouseCd: badWarehouseCd[0].warehouseCd,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [
		defaultPRD3011_R01HeaderDto, compCdList, workPlaceList, itemStatusList,
		wmsCdList, warehouseCdList, validateCommonCodeLists, validateWorkplaceWarehouse,
	]);

	const defaultPRD3011_R01DetailRow = useCallback(() => {
		return {
			...defaultPRD3011_R01DetailDto,
			inserted: true,
		};
	}, [defaultPRD3011_R01DetailDto]);

	const defaultPRD3011_R01DowntimeRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3011_R01_DOWNTIMEROW_VALIDATE, {
				downtimeValueList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3011_R01DowntimeDto }; }

		return {
			...defaultPRD3011_R01DowntimeDto,
			downtimeCase: downtimeValueList[0].minorCd,
			inserted: true,
		};
	}, [defaultPRD3011_R01DowntimeDto, downtimeValueList, validateCommonCodeLists]);

	const defaultPRD3011_R01InspectRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3011_R01_INSPECTROW_VALIDATE, {
				faultyValueList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3011_R01InspectDto }; }

		return {
			...defaultPRD3011_R01InspectDto,
			badCase: faultyValueList[0].minorCd,
			inserted: true,
		};
	}, [defaultPRD3011_R01InspectDto, faultyValueList, validateCommonCodeLists]);
	
	const initContainerData = useCallback(() => {
		initData();
		setPRD3011_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
		setEditPRD3011_R01({ ...defaultPRD3011_R01HeaderRow() });
	}, [initData, defaultLabelPrintAuto, setPRD3011_R01Filter, setEditPRD3011_R01, defaultPRD3011_R01HeaderRow]);

	const handleDeleteClick = useCallback(() => {

		// 비가동 - 불량내역 삭제 기능으로 변경하기
		if (deletedPRD3011_R01InspectList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구

			removeDeletedPRD3011_R01InspectList(deletedPRD3011_R01InspectList);
			removeSelectedPRD3011_R01InspectList();
			setPRD3011_R01InspectList([...PRD3011_R01InspectList]);

		} else if (selectedPRD3011_R01InspectList.length > 0) {

			addDeletedPRD3011_R01InspectList(selectedPRD3011_R01InspectList);
			removeSelectedPRD3011_R01InspectList(selectedPRD3011_R01InspectList);
		}

	}, [
		selectedPRD3011_R01InspectList, deletedPRD3011_R01InspectList, setPRD3011_R01InspectList, PRD3011_R01InspectList,
	]);
	
	const handleCreateClick = () => {
		const headerRow = defaultPRD3011_R01HeaderRow();
		if (!headerRow.inserted) return;

		const inspectRow = defaultPRD3011_R01InspectRow();
		if (!inspectRow.inserted) return;

		setSelectedPRD3011_R01(undefined);
		setEditPRD3011_R01({ ...headerRow });

		setPRD3011_R01InspectList([{ ...inspectRow }]);
		setDeletedPRD3011_R01InspectList([]);
		setSelectedPRD3011_R01InspectList([]);
		setOriginalPRD3011_R01InspectList([]);

		setDetailScrollTop(null);
		setInspectScrollTop(null);
	};

	const getProductResultHeaderDto = (header: PRD3011_R01HeaderDto) => {
		return {
			...header,
			workStartDt: toLocalDateTime(new Date()),
			workEndDt: toLocalDateTime(new Date()),
			productEmp: header.orderEmp,
			productEmpNm: header.orderEmpNm,
			kpiYn: '',
			inspectQty: 0,
			inspectYn: 'N',
		} as PRD3011_R01ProductResultDto;
	}

	const validateInsertData = (
		header: PRD3011_R01HeaderDto,
		detailList: PRD3011_R01DetailDto[],
		inspectList: PRD3011_R01InspectDto[]
	) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.workplaceCd)) {
			showWarning('공정명을 선택해주세요.'); return false;
		}
		if (!validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: header.workplaceCd,
		}).valid) {
			return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('입고창고를 선택해주세요.'); return false;
		}
		if (!validateString(header.orderEmp)) {
			showWarning('담당자를 입력해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.orderEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if ((header.productQty || 0) <= 0) {
			showWarning('생산양품량을 입력해주세요.'); return false;
		}

		const validateDetailList = detailList.filter(detail => 
			detail.isModified === true
		);
			
		if(validateDetailList.length === 0) {
			showWarning('자재출고 수정행을 입력해주세요. (최소 1개 이상 입력)'); return false;
		}
		//자재출고 검증
		if (detailList.length > 0) {
			for (const detail of detailList) {
				if (detail.transportQty > detail.lotQty) {
					showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`); return false;
				}
			}

			//childItemcd 기준으로 각 요소들을 분배해서 각 품목코드에 대한 출고량을 계산, 소요량과 비교해서 출고량이 소요량보다 클 수 없다
			// 현재는 수정해서 출고량이 소요량보다 높아도 되는데 롤백할 가능성이 있어서 코드를 보관함
			//
			const childItemcdList = detailList.map(detail => detail.childItemcd).filter(childItemcd => childItemcd);
			const uniqueChildItemcdList = Array.from(new Set(childItemcdList));
			for (const childItemcd of uniqueChildItemcdList) {
				const childItemcdDetailList = detailList.filter(detail => detail.childItemcd === childItemcd);
				const childItemcdTransportQty = childItemcdDetailList.reduce((sum, detail) => sum + detail.transportQty, 0);
				// if (childItemcdTransportQty > childItemcdDetailList[0].bomUsingQty) {
				// 	showWarning(`${childItemcd} 품목의 출고량은 소요량보다 클수 없습니다. `); return false;
				// }
			}
		}
		//불량수량 검증 (badCase별 badQty 합산 기준)
		if (inspectList.length > 0) {
			const deletedInspectListToNumber = deletedPRD3011_R01InspectList.map(value => Number(value));
			const badQtyValidation = validateEditBadQtyAgainstInspectList(
				header.badQty || 0,
				inspectList,
				deletedInspectListToNumber,
			);

			if (!badQtyValidation.valid) {
				showWarning(badQtyValidation.message!);
				return false;
			}
		}
		
		return true;
	}

	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editPRD3011_R01!, PRD3011_R01DetailList, PRD3011_R01InspectList)) valid = false;
		if(!valid) { return; }
		setLoadingSpinner(true);

		// 저장 전 품목 라벨 데이터 추출 (Lot라벨자동출력=Y일 때만). 저장 완료 후 출력
		let itemLabelData: ItemLabelPrintData | null = null;
		if (PRD3011_R01Filter.labelPrintAuto === 'Y') {
			try {
				itemLabelData = PRD3011_R01_buildItemLabelData(editPRD3011_R01!);
			} catch (labelBuildError) {
				console.error('품목 라벨 데이터 생성 실패:', labelBuildError);
			}
		}

		let processName = '';
		let newHeaderList: PRD3011_R01HeaderDto[] = [];
		let responseData: PRD3011_R01Dto = {
			productOrderHeaderDto: editPRD3011_R01!,
			productResultHeaderDto: getProductResultHeaderDto(editPRD3011_R01!),
			wmsStockLotDtoList: [],
			bomDtoList: PRD3011_R01DetailList,
			prdInspectResultDtoList: PRD3011_R01InspectList
		};
		let deleteHeaderFlag = false;

		try {
			if (selectedPRD3011_R01) {
				processName = 'patch';

				const deletedPRD3011_R01InspectList_Number = deletedPRD3011_R01InspectList.map(value => Number(value));
				const patchResponse = await patchPRD3011_R01({
					productOrderHeaderDto: editPRD3011_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editPRD3011_R01!),
					wmsStockLotDtoList: [],
					bomDtoList: PRD3011_R01DetailList,
					prdInspectResultDtoList: PRD3011_R01InspectList.filter(value => (
							!deletedPRD3011_R01InspectList_Number.includes(value.valueIndex) 
							&& validateString(value.badCase)
						)
					),
				});

				responseData = patchResponse.data.data;

				const responseProductOrderHeaderDto = {
					...responseData.productOrderHeaderDto,
					resultQty: responseData.productOrderHeaderDto.resultQty,
				};

				newHeaderList = PRD3011_R01List.map(value => {
					if (value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo) {
						return responseProductOrderHeaderDto;
					}
					return value;
				});
				if (editPRD3011_R01!.productQty >= editPRD3011_R01!.orderQty) {
					newHeaderList = PRD3011_R01List.filter(value => value.productOrderNo !== responseData.productOrderHeaderDto.productOrderNo);	
					deleteHeaderFlag = true;
				}
				
				if (patchResponse?.data?.data && patchResponse.data.successFlag) {
					showSuccess('생산실적이 등록 되었습니다.');
					setMessage('생산실적이 등록 되었습니다.');
				}else {
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			} else {
				processName = 'post';
				const postResponse = await postPRD3011_R01({
					productOrderHeaderDto: editPRD3011_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editPRD3011_R01!),
					wmsStockLotDtoList: [],
					bomDtoList: PRD3011_R01DetailList,
					prdInspectResultDtoList: PRD3011_R01InspectList.filter(value => (
						validateString(value.badCase)
					)),
				});
				responseData = postResponse.data.data;

				const responseProductWorkHeaderDto = {
					...responseData.productOrderHeaderDto,
					resultQty: 0
				};

				newHeaderList = [
					...PRD3011_R01List,
					responseProductWorkHeaderDto,
				] as PRD3011_R01HeaderDto[];
				
				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('생산실적이 등록 되었습니다.');
					setMessage('생산실적이 등록 되었습니다.');
				}else {
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
		} catch (error) {
			console.error("생산실적 작업 중 오류가 발생했습니다.:", error);
			showError('생산실적 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete' || deleteHeaderFlag) {
			setPRD3011_R01List(newHeaderList);

			setSelectedPRD3011_R01(undefined);
			setEditPRD3011_R01({ ...defaultPRD3011_R01HeaderRow() });
			setPRD3011_R01DetailList([]);

			setSelectedPRD3011_R01DetailList([]);

			setOriginalPRD3011_R01DetailList([]);

			setDeletedPRD3011_R01DetailList([]);

			deleteHeaderFlag = false;

			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setPRD3011_R01List(newHeaderList);

			const newEditPRD3011_R01 = {
				...responseData.productOrderHeaderDto,
				...responseData.productResultHeaderDto,
				orderQty: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty,
				productQty: 0,
				badQty: 0,
				orderEmp: responseData.productResultHeaderDto.productEmp,
				orderEmpNm: responseData.productResultHeaderDto.productEmpNm,
			};

			setEditPRD3011_R01(newEditPRD3011_R01);

			const aggregatedResponseBomList = aggregatePRD3011_R01DetailList(responseData.bomDtoList);
			const newDetailList = PRD3011_R01DetailList.filter(
				value => findAggregatedDetailItem(aggregatedResponseBomList, value) != null,
			).map(value => {
				const matched = findAggregatedDetailItem(aggregatedResponseBomList, value);
				return {
					...value,
					...matched,
					childItemUsage: value.childItemUsage,
					bomUsingQty: 0,
					transportQty: 0,
					isModified: false,
				};
			});
			setPRD3011_R01DetailList(newDetailList);
			setOriginalPRD3011_R01DetailList(newDetailList);
		}
		
		const inspectRow = defaultPRD3011_R01InspectRow();
		if (inspectRow.inserted) {
			setPRD3011_R01InspectList([{ ...inspectRow }]);
		} else {
			setPRD3011_R01InspectList([]);
		}
		setSelectedPRD3011_R01InspectList([]);
		setOriginalPRD3011_R01InspectList([]);
		setDeletedPRD3011_R01InspectList([]);

		setTimeout(() => {
			setMessage('');
		}, 5000);
		setLoadingSpinner(false);

		// 저장 완료 후 품목 라벨 출력 (Lot라벨자동출력=Y, 헤더삭제가 아닐 때만. PRD3010와 동일 흐름)
		if (
			PRD3011_R01Filter.labelPrintAuto === 'Y' &&
			itemLabelData &&
			!deleteHeaderFlag
		) {
			try {
				const ok = await printBulkItemLabel([itemLabelData]);
				if (ok) {
					showSuccess('저장 완료! 품목 라벨 출력');
				} else {
					showWarning('저장은 완료되었으나 라벨 출력에 실패했습니다. 프린터 설정을 확인해주세요.');
				}
			} catch (error: unknown) {
				const message = error instanceof Error ? error.message : '알 수 없는 오류';
				console.error('품목 라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${message}`);
			}
		}
	}, [
		PRD3011_R01Filter,
		PRD3011_R01List, setPRD3011_R01List,
		editPRD3011_R01,
		selectedPRD3011_R01,
		PRD3011_R01DetailList, setPRD3011_R01DetailList,
		PRD3011_R01InspectList, setPRD3011_R01InspectList, deletedPRD3011_R01InspectList,
		setLoadingSpinner,
		defaultPRD3011_R01HeaderRow, defaultPRD3011_R01InspectRow, defaultPRD3011_R01DowntimeRow,
		handleCreateClick,
		printBulkItemLabel,
	])

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleProductResultInfoCode = useCallback((headerData: PRD3011_R01HeaderDto): Partial<PRD3011_R01HeaderDto> => {
		const defaults: Partial<PRD3011_R01HeaderDto> = {};

		//날짜를 당일로 초기화
		defaults.productDt = formatDate(new Date());
				
		if(!validateString(headerData.compCd) && compCdList.length > 0)				defaults.compCd = compCdList[0].compCd;
		if(!validateString(headerData.workplaceCd) && workPlaceList.length > 0)		defaults.workplaceCd = workPlaceList[0].workplaceCd;

		if(!validateString(headerData.logicCenter) && wmsCdList.length > 0)			{
			defaults.logicCenter = wmsCdList[0].minorCd;
		}		
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;


		let warehouseListToUse = warehouseCdList.filter(value => (value.logicCenter === defaults.logicCenter
			&& (value.materialYn === 'Y' || value.goodsYn === 'Y' || value.productYn === 'Y')
		));
		if(!validateString(headerData.warehouseCd) && warehouseListToUse.length > 0)	{
			defaults.warehouseCd = warehouseListToUse[0].warehouseCd;
		}

		// productEmp가 있으면 productEmp을 사용, 없으면 orderEmp을 사용, 둘 다 없으면 employeeCdList[0].empNo를 사용
		defaults.orderEmp = headerData.productEmp ? headerData.productEmp : headerData.orderEmp ? headerData.orderEmp : '';
		defaults.orderEmpNm = headerData.productEmpNm ? headerData.productEmpNm : headerData.orderEmpNm ? headerData.orderEmpNm : '';

		defaults.badQty = headerData.badQty ? headerData.badQty : 0;
		defaults.productQty = headerData.productQty ? headerData.productQty : 0;
	
		return defaults;
	}, [selectedPRD3011_R01, compCdList, workPlaceList, employeeCdList, wmsCdList, warehouseCdList])

	const handleFetchBomProductList = useCallback(async ( itemCd: string, outWarehouseCd: string, logicCenter: string ) => {

		const responseData = (await getPRD3011_R01DetailStockList(itemCd, outWarehouseCd, logicCenter)).data.data;
		if(responseData && responseData.length > 0){
			const aggregatedStockList = aggregatePRD3011_R01DetailList(
				responseData.map((value, idx) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
				})),
			);

			const currentDetailList = usePRD3011_R01Store.getState().PRD3011_R01DetailList;
			const updatedDetails = currentDetailList.map((value) => {
				const response = findAggregatedDetailItem(aggregatedStockList, value);
				return {
					...value,
					warehouseCd: value.warehouseCd === outWarehouseCd ? outWarehouseCd : warehouseCdList[0].warehouseCd,
					warehouseNm: response ? response.warehouseNm : warehouseCdList[0].warehouseNm,
					logicCenter: value.logicCenter === logicCenter ? logicCenter : wmsCdList[0].minorCd,
					lotQty: response ? response.lotQty : 0,
				}
			});

			setPRD3011_R01DetailList(updatedDetails);
			setOriginalPRD3011_R01DetailList(aggregatedStockList);
			setMessage(`상세내역 ${aggregatedStockList.length}건을 조회하였습니다.`);
		} else {
			setOriginalPRD3011_R01DetailList([]);
		}
		detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		setTimeout(() => setMessage(""), 5000);


	}, [editPRD3011_R01?.itemCd, editPRD3011_R01?.warehouseCd, editPRD3011_R01?.logicCenter, warehouseCdList, wmsCdList, setPRD3011_R01DetailList, setOriginalPRD3011_R01DetailList, setMessage, detailGridRef])

	const fetchDetailList = useCallback(async (itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string) => {
		const response = await getPRD3011_R01DetailList(itemCd, productQty, badQty, outWarehouseCd, logicCenter);
			
		if (response.data && response.data.successFlag === false) {
			showWarning(response.data.message);
			setPRD3011_R01DetailList([]);
			return;
		}

		const responseData = response.data.data;

		if(responseData && responseData.length > 0){
			const normalizedList = responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
				lotQty: value.lotQty ?? 0,
				transportQty: 0,
				transportedQty: 0,
			}));
			const aggregatedDetailList = aggregatePRD3011_R01DetailList(normalizedList);
			setPRD3011_R01DetailList(aggregatedDetailList);
			setOriginalPRD3011_R01DetailList(aggregatedDetailList);
			setDetailScrollTop(null);
			setMessage(`자재출고 ${aggregatedDetailList.length}건을 조회하였습니다. (LOT ${responseData.length}건 취합)`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			setPRD3011_R01DetailList([]);
			setOriginalPRD3011_R01DetailList([]);
		}

		return;
	}, [setPRD3011_R01DetailList, setOriginalPRD3011_R01DetailList, setDetailScrollTop, setMessage]);

	//생산결과가 있는 작업지시 정보 조회
	const fetchProductResult = useCallback(async (headerData: PRD3011_R01HeaderDto) => {

		let apiHeaderData: PRD3011_R01ProductResultDto | null = null;
		try {
			const transportResponse = await getPRD3011_R01ProductResultList(headerData.productOrderNo!);
			apiHeaderData = transportResponse.data.data;
			
			let baseDataForDefaults;
			if (apiHeaderData && apiHeaderData.productResultNo) {
				setProductResultComplete(true);
				baseDataForDefaults = { 
					...defaultPRD3011_R01HeaderRow(),
					...headerData,
					...apiHeaderData,
					orderQty: headerData.orderQty - headerData.resultQty,
					productQty : 0,
					badQty : 0, // 불량수량 0 고정(초기화)
					itemStatus: apiHeaderData.itemStatus ? apiHeaderData.itemStatus : itemStatusList[0]?.minorCd ?? '',
				};
			} else {
				setProductResultComplete(false);
				baseDataForDefaults = { 
					...defaultPRD3011_R01HeaderRow(),
					...headerData,
				};
			}
			

			const defaultValues = handleProductResultInfoCode(baseDataForDefaults);

			setEditPRD3011_R01({	
				...baseDataForDefaults,
				...defaultValues,
			});

		} catch (error) {
			console.error("ProductResult 내역 조회 실패:", error);
			setProductResultComplete(false);
		}

		if(apiHeaderData && apiHeaderData.productResultNo) {
			return apiHeaderData;
		} else {
			return null;
		}
	}, [setProductResultComplete, defaultPRD3011_R01HeaderRow, itemStatusList, handleProductResultInfoCode, setEditPRD3011_R01]);

	const handleFetchDetailData = useCallback(() => {
		if (!detailFetchTrigger) return;
		
		setDetailScrollTop(null);
		setInspectScrollTop(null);
		setPRD3011_R01DetailList([]);
		setPRD3011_R01InspectList([]);

		const fetchAllData = async () => {
			if (selectedPRD3011_R01) {

				const headerData = await fetchOne();
				if(!headerData) return;

				const productResult: PRD3011_R01ProductResultDto | null = await fetchProductResult(headerData);
				if(productResult && productResult.productResultNo !== '') {

					await fetchDetailList(
						productResult?.itemCd || '',
						productResult?.productQty ?? 0,
						productResult?.badQty ?? 0,
						headerData.outWarehouseCd,
						headerData.logicCenter
					);
				}else{
					await fetchDetailList(
						headerData?.itemCd || '',
						headerData?.productQty ?? 0,
						0,
						headerData.outWarehouseCd,
						headerData.logicCenter
					);

				}

				if (productResult && productResult.productResultNo !== '') {

					await handleFetchBomProductList(
						productResult.itemCd,
						headerData.outWarehouseCd,
						productResult.logicCenter || (editPRD3011_R01?.logicCenter ?? wmsCdList[0].minorCd)
					);
				}
				setPRD3011_R01InspectList([]);
				const inspectRow = defaultPRD3011_R01InspectRow();
				if (inspectRow.inserted) {
					insertPRD3011_R01InspectList([{ ...inspectRow }]);
				}
			}
		};

		fetchAllData();
		setDetailFetchTrigger(false);

	}, [
		selectedPRD3011_R01, detailFetchTrigger, setDetailFetchTrigger,
		fetchOne, fetchProductResult, fetchDetailList,
		setPRD3011_R01DetailList, setPRD3011_R01InspectList,
		handleFetchBomProductList, editPRD3011_R01, wmsCdList,
		insertPRD3011_R01InspectList, defaultPRD3011_R01InspectRow,
		setDetailScrollTop, setInspectScrollTop,
	]);

	useEffect(() => {
		setPRD3011_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
	}, [defaultLabelPrintAuto, setPRD3011_R01Filter]);

	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultPRD3011_R01HeaderRow,
		defaultPRD3011_R01DetailRow,
		defaultPRD3011_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleFetchBomProductList,
		handleFetchDetailData,
	};
}
